import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import gu from "./locales/gu.json";
import bn from "./locales/bn.json";

export const SUPPORTED_LOCALES = [
  { code: "en", label: "English",     native: "English",   // Google Translate target
    gt: "en" },
  { code: "hi", label: "Hindi",       native: "हिन्दी",     gt: "hi" },
  { code: "gu", label: "Gujarati",    native: "ગુજરાતી",   gt: "gu" },
  { code: "bn", label: "Bengali",     native: "বাংলা",     gt: "bn" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      gu: { translation: gu },
      bn: { translation: bn },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES.map((l) => l.code),
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hopsy_locale",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false }, // React escapes by default
  });

export default i18n;
